import R from 'ramda';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { Link } from 'react-router';
import { Row, Col } from 'react-bootstrap';
import PhotoContainer from '../PhotoContainer';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import { PublishesID } from '../../constants';
import {
  getRoleNames,
  getMemberByUserId,
  getWorkTypeNameById,
  getOwnershipTypeName,
} from '../../utils';

class TeamMembers extends Component {
  constructor() {
    super();
    this.state = {
      current: null,
    };
  }

  componentWillMount() {
    const { type, team, teamId } = this.props;

    if (type === 'create' && team) {
      this.props.loadMembers(team.id);
    } else {
      this.props.loadMembers(teamId);
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      type,
      work,
      team,
      members,
      workOwnerships,
      teamStatus,
      userStatus,
    } = nextProps;

    if (type === 'create' && team) {
      if (
        userStatus !== this.props.userStatus &&
        userStatus === actionTypes.MEMBERS_GET_SUCCESS &&
        members &&
        members.length
      ) {
        this.props.setWorkOwnerships(
          members.map((member) => ({
            user: member.user,
            ownership_type: member.ownership.ownership_type,
            percentage: member.ownership.percentage,
            role_ids: member.role_ids,
          }))
        );
      }
    } else if (work && !team && teamStatus !== actionTypes.TEAM_GET_REQUEST) {
      this.props.loadTeam(work.team);
    }

    if (this.state.current === null) {
      if (type === 'create') {
        if (workOwnerships && workOwnerships.length) {
          this.setState({ current: workOwnerships[0] });
        }
      } else if (
        work &&
        work.work_ownership_info &&
        work.work_ownership_info.length
      ) {
        this.setState({ current: work.work_ownership_info[0] });
      }
    }
  }

  getTeamMembers() {
    const { work, members, type, workOwnerships } = this.props;
    let ownerships = [];

    if (type === 'create' && workOwnerships) {
      ownerships = workOwnerships;
    } else if (work && work.work_ownership_info) {
      ownerships = work.work_ownership_info;
    }

    if (ownerships.length) {
      return ownerships.map((member, i) => {
        let selected = false;
        let avatar = '';

        if (this.state.current && member.user === this.state.current.user)
          selected = true;

        const memberInfo = getMemberByUserId(member.user, members);
        if (memberInfo && memberInfo.user_info) {
          avatar = memberInfo.user_info.avatar;
        }

        return (
          <PhotoContainer
            key={i}
            className={`photo-container ${selected && 'selected'}`}
            image={avatar}
            onClick={() => this.changeCurrent(member)}
            defaultImg="user"
          />
        );
      });
    }
  }

  changeCurrent(member) {
    this.setState({ current: member });
  }

  renderCurrentMember() {
    const { roles, members, type } = this.props;
    const { current } = this.state;

    if (current) {
      const member = getMemberByUserId(current.user, members);

      if (member && member.user_info) {
        const user = member.user_info;
        const roleNames = getRoleNames(current.role_ids, roles);

        return (
          <div className="member-info">
            <PhotoContainer
              className="photo-container"
              image={user.avatar}
              defaultImg="user"
            />
            <div className="current-info">
              {user.company_name && user.use_company_name ? (
                <div className="user-name">{user.company_name}</div>
              ) : null}
              <div className="user-name">{user.name}</div>
              <div className="user-email">{user.email}</div>
              <div className="user-roles">{roleNames.join(', ')}</div>
            </div>
            <div className="edit-link">
              {type === 'create' && (
                <a onClick={() => this.props.onEdit()}>edit</a>
              )}
            </div>
          </div>
        );
      }
    }
  }

  renderWorkOwnership(work, withPublishers) {
    const { agreement, contractBlocks, dealBlocks, profile, ownershipTypes } =
      this.props;

    let licenserIds = agreement.licenser_ids || [];
    const deals = agreement.deals || [];
    const block = R.find(R.propEq('name', 'Licensing Permissions'))(
      contractBlocks
    );

    if (block && block.options) {
      licenserIds = block.options.licenserIds || [];
    }

    if (work.work_ownership_info && work.work_ownership_info.length) {
      const ownerships = R.clone(work.work_ownership_info);

      let deal = R.find(R.propEq('work', work.id))(deals);
      let dealUsers = [];
      if (deal) {
        dealUsers = deal.deal_users || [];
      }

      const rows = [];
      let i = 0;
      ownerships.forEach(({ user, ownership_type, percentage }) => {
        if (user === this.state.current.user) {
          let publishers = [];
          if (withPublishers) {
            const dealUser = R.find(R.whereEq({ user: user, type: 'member' }))(
              dealUsers
            );
            publishers =
              dealUser && dealUser.publishers ? dealUser.publishers : [];

            if (
              dealBlocks &&
              deal &&
              (profile.id === user || profile.id === deal.user)
            ) {
              let dealBlock = R.find(R.propEq('id', PublishesID))(dealBlocks);

              if (dealBlock && dealBlock.changes && dealBlock.changes.adjust) {
                publishers = R.filter(
                  (publisher) => publisher.userId === user,
                  dealBlock.changes.publishers
                );
              }
            }
          }

          const ownershipType = getOwnershipTypeName(
            ownership_type,
            ownershipTypes
          );
          const contributorData =
            ownershipType === 'No Ownership'
              ? 'No Ownership'
              : `${percentage}% ownership of the ${ownershipType}`;
          const permissionToLicense =
            agreement.type === 'premium'
              ? licenserIds.indexOf(user) !== -1
                ? 'Yes'
                : 'No'
              : null;

          rows.push(
            <div key={i}>
              <div>
                <span className="text-blue">Ownership: </span>
                <span>{contributorData}</span>
              </div>
              {publishers.map(
                ({ publisher_name, society, publisher_share }, index) => (
                  <div key={index}>
                    {index === 0 && <span>Publisher Share: </span>}
                    <span
                      className={`text-blue ${
                        index !== 0 && 'duplicate-publisher'
                      }`}
                    >
                      {`${
                        parseFloat(publisher_share, 10) || 0
                      }% ${publisher_name} (${society})`}
                    </span>
                  </div>
                )
              )}
              {agreement.type !== 'split' && (
                <div>
                  <span>Permission to License: </span>
                  <span className="text-blue">{permissionToLicense}</span>
                </div>
              )}
            </div>
          );

          i++;
        }
      });

      return rows;
    }
  }

  renderOwnership() {
    const { work, type, agreement, hideValue, members, workTypes } = this.props;
    const { current } = this.state;

    if (current) {
      let withPublishers = false;
      if (work.type) {
        const workTypeName = getWorkTypeNameById(work.type, workTypes);
        withPublishers = workTypeName === 'Music';
      }

      if (type === 'detail') {
        if (hideValue) {
          let userList = [];
          if (agreement.deals) {
            agreement.deals.map((deal) => {
              const member = getMemberByUserId(deal.user, members);
              const work = deal.work_info;

              userList = [
                ...userList,
                {
                  user: member && member.user_info ? member.user_info.name : '',
                  work: work.name,
                },
              ];
              return userList;
            });
          }

          return (
            <div className="member-ownership">
              {userList.length > 0 && (
                <Row>
                  {/* <Col md={4} className="text-blue"><b>Agreement creator:</b></Col>
                                    <Col md={8}><b>{userList[0].user}</b></Col> */}
                  <Col md={4} className="text-blue mt-10px">
                    <b>Works:</b>
                  </Col>
                  <Col md={8} className="split-work-view mt-10px">
                    {userList.map((data, index) => (
                      <div key={index}>{data.work}</div>
                    ))}
                  </Col>
                </Row>
              )}
            </div>
          );
        }

        return (
          <div className="member-ownership">
            <Row>
              <Col md={8}>{this.renderWorkOwnership(work, withPublishers)}</Col>
            </Row>
          </div>
        );
      }

      return (
        <div className="member-ownership">
          <Row>
            <Col md={8}>{this.renderWorkOwnership(work, withPublishers)}</Col>
          </Row>
        </div>
      );
    }
  }

  render() {
    const { team } = this.props;

    if (team) {
      return (
        <div className="team-module">
          <Row>
            <Col sm={4}>
              <div className="team">
                <div className="top">
                  <div className="team-photo">
                    <PhotoContainer
                      className="photo-container"
                      image={team.avatar}
                      defaultImg="team"
                    />
                  </div>
                  <div className="team-title">{team.name}</div>
                </div>
                <div className="team-images">{this.getTeamMembers()}</div>
              </div>
            </Col>
            <Col sm={8}>
              <div className="member-details">
                {this.renderCurrentMember()}
                {this.renderOwnership()}
                {(this.props.agreeType === 'workforhire' ||
                  this.props.agreeType === 'producer') && (
                  <div className="text-red">
                    These are the default ownership splits for your
                    collaborators in this agreement. To apply these ownership
                    splits to the work(s) click "next". To propose new ownership
                    splits for the work(s), click on "edit".
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  roles: state.global.roles,
  contractBlocks: state.global.contractBlocks,
  workTypes: state.global.workTypes,
  ownershipTypes: state.global.ownershipTypes,
  team: state.teams.selectedTeam,
  teamStatus: state.teams.status,
  members: state.users.members,
  userStatus: state.users.status,
  workOwnerships: state.workOwnerships.workOwnerships,
  agreement: state.agreements.selectedAgreement,
  dealBlocks: state.dealBlocks.dealBlocks,
  deal: state.deals.selectedDeal,
  dealUsers: state.dealUsers.dealUsers,
  profile: state.profile,
});

const mapDispatchToProps = (dispatch) => ({
  loadTeam: (teamId) => {
    dispatch(actions.getTeam(teamId));
  },
  loadMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
  setWorkOwnerships: (workOwnerships) => {
    dispatch(actions.setWorkOwnerships(workOwnerships));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamMembers);



// WEBPACK FOOTER //
// src/components/Agreements/TeamMembers.jsx